import { css } from 'styled-components'

const criticalButtonTemplate = () => css`
  background: var(--sl-bg-critical-strong);
  color: var(--sl-fg-inverted);

  &:hover {
    background: var(--sl-bg-critical-strong-hover);
  }

  &.active {
    background: var(--sl-bg-critical-strong-pressed);
  }

  &:focus-visible {
    box-shadow: var(--sl-focus-ring-critical);
    background: var(--sl-bg-critical-strong-hover);
  }

  &:disabled {
    background: var(--sl-bg-base-strong-disabled);
  }
`

export default criticalButtonTemplate
